import { t } from "@lingui/macro";
import { Select, type SelectOptions } from "@src/components/ui-kit";
import { fieldToSelectProps } from "@src/utils/forms/inputHelpers";
import { useStore } from "@src/utils/hooks";
import { workspaceCompanies } from "@src/utils/map-to-options/workspace-companies";
import type { FieldState } from "formstate";
import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import type { FC } from "react";

type Props = {
  field: FieldState<string>;
  showLabel?: boolean;
  onChange?: (value: string) => void;
  asPortal?: boolean;
  isDisabled?: boolean;
};

export const CompanySelect: FC<Props> = observer(function CompanySelect({
  field,
  onChange,
  showLabel = false,
  asPortal,
  isDisabled,
}) {
  const { workspaceStore } = useStore();

  const companyOptions: SelectOptions = computed(() => {
    return workspaceCompanies(
      workspaceStore.companies.filter(({ id, deleted }) => {
        return id === field.value || !deleted;
      }),
    );
  }).get();

  return (
    <Select
      asPortal={asPortal}
      isDisabled={isDisabled}
      label={showLabel ? t`Legal entity` : undefined}
      {...fieldToSelectProps(field, companyOptions, (val) => {
        onChange?.(val);
        return val;
      })}
    />
  );
});
